export function getSocketURL() {
	const isDev = process.env.NODE_ENV === 'development';

	let hostname = '';
	const wsEndpoint = '/wsbridge/v1/game/orbital.creepycashclassic';

	if (isDev) {
		hostname = 'dev.orbitalgaming.io';
		// hostname = '192.168.88.68:10045';
	} else {
		hostname = window.location.hostname;
	}

	return `wss://${hostname}${wsEndpoint}`;
}
